export const blockIconsActionFingerprint = (
	<span className='material-symbols-outlined'>fingerprint</span>
);
